<script>
  export let message;

  import { fade } from "svelte/transition";

  let visible = false;
  let timer;

  $: if (message && message !== "") {
    visible = true;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      visible = false;
    }, 5000);
  }
</script>

{#if visible}
  <div transition:fade><span>{message}</span><br />copied to clipboard</div>
{/if}

<style>
  div {
    padding: 10px;
    background-color: rgba(50, 200, 50, 0.8);
  }
  div > span {
    font-family: monospace;
  }
</style>
